module.exports = __webpack_public_path__ + "static/Proces pozyskiwania dystrybutorow-75161574aa32c68a13cde9d63dede62a.jpg";